import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-harvest-save-btn',
    templateUrl: './harvest-save-btn.component.html',
    styleUrls: ['./harvest-save-btn.component.scss'],
    standalone: false
})
export class HarvestSaveBtnComponent implements OnInit {
  @Input() disabled: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
